import React, { useEffect, useState } from 'react'
import st from './CardsFunnelName.module.scss'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import FormField from 'components/UI/AsideModal/Form/FormField'
import MultiSelectWithCheckBox from '../../UI/components/MultiSelectWithCheckBox/MultiSelectWithCheckBox'
import { superAxiosRequest } from 'axiosApi'
import AddingFunnels from '../AddingFunnels/AddingFunnels'
import { HeaderButton } from 'components/UI/SuperButton/SuperButton'
import { TrashIcon } from 'components/CRM/UI/icons/iconComponents/TrashIcon'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import SettingDealFields from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/CustomerCardSettings/CustomerCardSettings'
import asideModalStore from 'Stores/asideModalStore'
import useLocalization from 'hooks/useLocalization'

const CardsFunnelName = () => {
  const [data, setData] = useState([])
  const [executors, setExecutors] = useState([])
  const [funnelsTitles, setFunnelsTitles] = useState({})

  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'crm_settings',
    dict: {
      save: 'Save',
      access: 'Access',
      funnel_name: 'Funnel name',
      funnel: 'Funnel',
      select_options: 'Select options',
      deal_fields: 'Deal fields',
    },
  })

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'integration/funnels',
      params: {},
      crm: true,
    })
      .then(({ data }) => {
        setFunnelsTitles(
          data?.reduce((acc, el) => {
            acc[el?.id] = el?.name
            return acc
          }, {}),
        )
        setData(data)
      })
      .catch((error) => {
        console.error('Error fetching funnels:', error)
      })
  }, [])

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'integration/employees',
      params: {
        limit: 999,
        short_form: true,
      },
      crm: true,
    })
      .then(({ data }) => {
        const formattedExecutors = data
          ?.map((executor) => ({
            value: executor?.id.toString(),
            label: executor?.name,
          }))
          .sort((a, b) => a.label.localeCompare(b.label))

        setExecutors(formattedExecutors)
      })
      .catch((error) => {
        console.error('Error fetching executors:', error)
      })
  }, [])

  const updateFunnel = (funnelId, payload) => {
    const formattedPayload = {
      ...payload,
      employees: payload.employees.map((employee) => employee.id || employee),
    }
    superAxiosRequest(
      {
        method: 'put',
        link: `integration/funnels/${funnelId}`,
        crm: true,
      },
      formattedPayload,
    )
      .then((response) => {
        setData(
          data?.map((el) =>
            el?.id === response?.data?.id ? { ...el, ...response?.data } : el,
          ),
        )
      })
      .catch((error) => {
        console.error('Error sending data', error)
      })
  }
  const handleNameChange = (e, funnelId) => {
    setFunnelsTitles({
      ...funnelsTitles,
      [funnelId]: e?.currentTarget?.value,
    })
  }

  const handleEmployeesUpdate = (funnelForUpdateId, employeeToUpdateId) => {
    const currentFunnel = {
      ...data?.find((el) => el.id === Number(funnelForUpdateId)),
    }

    if (
      currentFunnel?.employees?.some(
        (el) => el?.id === Number(employeeToUpdateId),
      )
    ) {
      currentFunnel.employees = currentFunnel?.employees?.filter(
        (el) => el?.id !== Number(employeeToUpdateId),
      )
    } else {
      currentFunnel.employees = [
        ...(currentFunnel.employees.map((el) => el?.id) || []),
        Number(employeeToUpdateId),
      ]
    }

    updateFunnel(funnelForUpdateId, {
      ...currentFunnel,
      employees: currentFunnel?.employees,
    })
  }

  const handleNameBlur = (funnelId) => {
    const currentFunnel = { ...data?.find((el) => el.id === funnelId) }
    currentFunnel.name = funnelsTitles?.[funnelId]
    updateFunnel(funnelId, currentFunnel)
  }

  const deleteFunnel = (funnelId) => {
    superAxiosRequest({
      method: 'delete',
      link: `integration/funnels/${funnelId}`,
      crm: true,
    })
      .then(() => {
        setData(data?.filter((el) => el.id !== funnelId))
      })
      .catch((error) => {
        console.error('Error deleting funnel', error)
      })
  }

  const addFunnel = (newFunnel) => {
    setData([...data, newFunnel])
    setFunnelsTitles({
      ...funnelsTitles,
      [newFunnel?.id]: newFunnel?.name,
    })
  }

  // Модалка для добавления кастомных полей воронки
  const customerCardSettings = (funnelId) => {
    const ms = {
      modalBodyComponent: () => <SettingDealFields funnelId={funnelId} />,
      button: translate.save,
      link: 'integration/additional_funnel_deal_fields',
      title: translate.deal_fields,
      isResponsive: true,
      crm: true,
      onBeforeSubmit: () => {
        const payload = {
          funnel: +funnelId,
          additional_funnel_deal_fields:
            asideModalStore.modalValues.additional_funnel_deal_fields.map(
              (field) => ({
                ...field,
                is_required: field.is_required || false,
              }),
            ),
        }
        return payload
      },
      onSubmitSuccess: () => {},
    }
    asideModalStore.activity(ms, {})
  }

  return (
    <div className={st.containerForFunnels}>
      <AddingFunnels
        addFunnel={addFunnel}
        executors={executors}
        isAddingDisable={data?.length >= 5}
      />
      <div className={st.container}>
        {data?.map((card, index) => {
          return (
            <div key={card.id} className={st.greyContainer}>
              <div className={st.middleContainer}>
                <div className={st.inputAndBtns}>
                  <div className={st.containerForButtonAndName}>
                    <FormLabel isRequired>
                      {' '}
                      <span
                        className={st.title}
                      >{`${translate.funnel} ${index + 1}: ${card?.name}`}</span>
                    </FormLabel>

                    <FormField>
                      <FormInput>
                        <input
                          placeholder={translate.funnel_name}
                          type={'text'}
                          maxLength={50}
                          value={funnelsTitles?.[card?.id]}
                          onChange={(e) => handleNameChange(e, card?.id)}
                          onBlur={() => handleNameBlur(card.id)}
                        />
                      </FormInput>
                    </FormField>
                  </div>

                  <div className={st.btns}>
                    <HeaderButton
                      hidePlus
                      title={translate.deal_fields}
                      onClick={() => customerCardSettings(card.id)}
                    />
                    {!card?.is_system && (
                      <div
                        className={st.trashIcon}
                        onClick={() => deleteFunnel(card.id)}
                      >
                        <TrashIcon fill={'#B2BEC3'} />
                      </div>
                    )}
                  </div>
                </div>

                <div className={st.namesContainer}>
                  <div className={st.title}>{translate.access}:</div>
                  <MultiSelectWithCheckBox
                    translation={translate}
                    options={executors}
                    currentCard={card}
                    onChange={(employeeForUpdateId) =>
                      handleEmployeesUpdate(card.id, employeeForUpdateId)
                    }
                  />
                </div>

                <div className={st.btnsMobile}>
                  <HeaderButton
                    hidePlus
                    title={translate.deal_fields}
                    onClick={() => customerCardSettings(card.id)}
                  />

                  {!card?.is_system && (
                    <div
                      className={st.trashIcon}
                      onClick={() => deleteFunnel(card.id)}
                    >
                      <TrashIcon fill={'#B2BEC3'} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
export default CardsFunnelName
